module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "breadcrumbsData": _vm.breadcrumbData
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("Add Funds request")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-margin"
  }, [_c('div', {
    staticClass: "modal-body mt-lg"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.investmentAmount),
      expression: "investmentAmount"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control text-right input-md': true, 'form-control-error': _vm.isInvestmentAmountInvalid
    },
    attrs: {
      "autocomplete": "off",
      "name": "investmentAmount",
      "id": "investmentAmount"
    },
    domProps: {
      "value": (_vm.investmentAmount)
    },
    on: {
      "change": _vm.removeNegative,
      "blur": function($event) {
        _vm.validateInvestmentAmount()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.investmentAmount = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isInvestmentAmountInvalid) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.investmentAmountError))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("Please append your comment below *")]), _vm._v(" "), _c('restricted-textarea', {
    attrs: {
      "input": _vm.comment,
      "limit": 255,
      "id": "comment",
      "placeholder": "",
      "required": true
    },
    on: {
      "inputUpdated": _vm.commentUpdated
    }
  }), _vm._v(" "), (!_vm.comment || _vm.information.comment === _vm.comment) ? _c('p', {
    staticClass: "top-margin",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', [_vm._v("You must enter or append a comment.")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-white buttons",
    attrs: {
      "type": "submit",
      "disabled": !_vm.information.isNewRequest && _vm.isCancelButtonDisabled()
    },
    on: {
      "click": function($event) {
        _vm.information.isNewRequest ? _vm.goToNoteDetail() : _vm.showCancelConfirmationModal()
      }
    }
  }, [_vm._v("Cancel request")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg button-white buttons",
    attrs: {
      "type": "submit",
      "disabled": _vm.information.isNewRequest || _vm.isButtonDisabled()
    },
    on: {
      "click": _vm.submitApproveAddFunds
    }
  }, [_vm._v("Approve Add Funds")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg button-approve buttons",
    attrs: {
      "type": "submit",
      "disabled": !_vm.information.isNewRequest || _vm.isButtonDisabled()
    },
    on: {
      "click": _vm.submitRequest
    }
  }, [_vm._v("Submit request")])])])])])])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      All users\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Enter investment amount "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cea242e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddFunds.vue
// module id = 2203
// module chunks = 1